import { isSameDay, isSameHour, isSameMonth, isSameWeek, parseISO } from "date-fns";

import DistanceRecord from "@mapmycustomers/shared/types/entity/Distance";

type DistanceRow = Pick<DistanceRecord, "date" | "totalDistance">;
export interface DistanceBucket {
  date: Date;
  distance: number;
}

const sameBucket: Record<string, (a: Date, b: Date) => boolean> = {
  day: isSameDay,
  hour: isSameHour,
  month: isSameMonth,
  week: isSameWeek,
};

export const rollUpDistance = (
  rows: DistanceRow[],
  buckets: Date[],
  granularity: string
): DistanceBucket[] => {
  const matches = sameBucket[granularity] ?? isSameDay;
  // parseISO, not parseApiDate: `date` is a zone-less calendar date matched against local-midnight
  // buckets, so it must parse to local midnight. parseApiDate reads it as UTC and lands on the
  // previous day for negative-offset zones.
  const parsed = rows.map((row) => ({ date: parseISO(row.date), distance: row.totalDistance }));
  return buckets.map((bucketDate) => ({
    date: bucketDate,
    distance: parsed
      .filter((row) => matches(row.date, bucketDate))
      .reduce((sum, row) => sum + (row.distance ?? 0), 0),
  }));
};

export default rollUpDistance;
